<template>
  <v-app-bar app class="primary" dark height="75">
    <app-confirm ref="confirm"></app-confirm>
    <div class="align-center">
      <h2>{{ Title }}</h2>
      <div class="mx-10 version">{{ siteVersion }}</div>
    </div>
    <v-spacer></v-spacer>
    <div class="mx-auto text-center d-none d-md-block">
      <h2 v-show="page.displayPageTitle">{{ page.description[Language] }}</h2>
    </div>
    <v-spacer></v-spacer>
    <v-btn
      depressed
      outlined
      id="toggle"
      class="primary btn-toggle mr-5"
      @click="chageFontSize"
    >
      <v-icon v-if="!toggle">$apIncreaseFont</v-icon>
      <v-icon v-else>$apDecreaseFont</v-icon>
    </v-btn>
    <v-select
      class="mt-7 language-select controlled-font mr-5"
      :items="Languages"
      item-text="name"
      item-value="code"
      :value="Language"
      @change="changeLanguage"
      dense
      outlined
      v-show="page.displayLangaugeSelection"
    ></v-select>
    <v-btn
      outlined
      id="logout"
      class="primary logout"
      @click="logout()"
      v-show="loggedIn && showLogoutButton"
    >
      Logout
    </v-btn>
  </v-app-bar>
</template>

<script>
import { mapGetters } from "vuex";
import { mapActions } from "vuex";
import appConfirm from "./ui/Confirm.vue";

export default {
  components: {
    appConfirm,
  },
  computed: {
    ...mapGetters({
      Title: "title",
      Language: "selectedLanguage",
      Languages: "languages",
      siteVersion: "siteVersion",
      page: "page",
      loggedIn: "loggedIn",
      showLogoutButton: "showLogoutButton",
      siteText: "siteText",
    }),
  },
  methods: {
    ...mapActions(["setLanguage", "toggleFontSize", "finished"]),
    changeLanguage(value) {
      this.setLanguage(value);
    },
    chageFontSize() {
      this.toggle = !this.toggle;
      this.toggleFontSize(this.toggle);
    },
    async logout() {
      var confirm = await this.$refs.confirm.open(
        this.siteText.ui.confirmation,
        this.siteText.ui.logoutConfirmation,
        {
          ok: this.siteText.ui.yes,
          cancel: this.siteText.ui.no,
        }
      );
      if (confirm) {
        this.finished();
      }
    },
  },
  data() {
    return {
      toggle: false,
    };
  },
};
</script>

<style scoped>
.language-select {
  max-width: 200px;
}

.btn-toggle {
  width: 25px !important;
  min-height: 25px;
  margin: -10px;
}
.btn-toggle.v-btn--outlined {
  border-color: rgba(255, 255, 255, 0.7) !important;
}
.version {
  font-size: 10px;
}

.logout {
  max-width: 85px;
}

.logout.v-btn {
  min-height: 38px !important;
}

.logout.v-btn--outlined {
  border-color: rgba(255, 255, 255, 0.7) !important;
}

@media screen and (max-width: 600px) {
  h2 {
    font-size: 18px !important;
  }

  .language-select {
    max-width: 150px;
  }
}
</style>
